// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__WQTDL","wrapper__button":"Button_wrapper__button__xtWwK","wrapper__button__white":"Button_wrapper__button__white__fM-g8"};